var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 72 60",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEA102",
    fillRule: "evenodd",
    d: "M34.595 10.8c2.309.03 3.312 2.502 4.243 3.966 2.131 3.36 3.533 7.29 4.382 11.966q.072 2.016.14 4.032h.072c1.92-1.19 1.699-4.723 4.66-4.589 4.47 4.8 2.54 13.771-.278 18.571-.864 1.479-2.535 5.405-4.522 3.898.044-2.803.423-8.074-1.53-9.254l-.28-.068-.278.207c-.09.96-.293 1.641-.835 2.16h-.346c-.48-.763-.393-1.92-.628-2.99-.48-2.117-1.772-7.292-3.84-7.517-1.234.595-1.44 2.356-2.155 3.48-1.7 2.77-3.768 5.05-4.733 8.64-.341 1.276.336 4.732-.207 5.424-.206.345-.523.456-1.046.48-4.047-3.384-8.06-12.274-5.213-19.479 1.92-4.896 5.669-8.342 8.64-12.245l2.155-3.475c.59-1.42.437-2.39 1.599-3.206",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotIcon);
export default __webpack_public_path__ + "static/media/HotIcon.d52acef506dddbc8bafeeaa16b20c208.svg";
export { ForwardRef as ReactComponent };